module.exports = __webpack_public_path__ + "static/home1-0854817aa53bdc85b442afe42d58bdff.jpg";